module.exports = __webpack_public_path__ + "media/components/Cards/images/plastic_black-16e5cfcf98e1482ef8d57bda2a743bb9.png";